module.exports = __webpack_public_path__ + "static/media/Icon material-remove-red-eye.6915d176.svg";